/**
 * Created by netre on 27.06.2017.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { CircleBar } from '../../CircleBar';

export const HighChartsFormatter = (props) => {
  const { date, points, score } = props;
  return (
    <div>
      <div className="tooltipDate">
        {date}
      </div>
      {score > 0 && <CircleBar score={score} /> }
      <div className="holder">
        {points.map((point, index) => <div className="tooltipWrap" key={index}><span className="ico" /><span>{point.y}</span></div>)}
      </div>
    </div>
  );
};

HighChartsFormatter.propTypes = {
  score: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  points: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  })).isRequired,
};

export { default as placeholderConfig } from './Placeholder';




// WEBPACK FOOTER //
// ./src/components/Dashboard/Highcharts/index.js